// extracted by mini-css-extract-plugin
export default {"content":"OfflineNotificationModal_content__KeNGm","dialogText":"OfflineNotificationModal_dialogText__kJWji"};